import axios from "axios";
import { isSessionTimeoutError } from "./auth";
import { viewerReset } from "../domain/session";
var isDevelopment = process.env.NODE_ENV !== "production";
var withCredentials = isDevelopment;
export var baseURL = isDevelopment ? "http://localhost" : "";
export var apiURL = "".concat(baseURL, "/api/v2");
var base = axios.create({
    baseURL: baseURL,
    withCredentials: withCredentials,
    headers: {
        "Accept-Language": localStorage.getItem("i18nextLng"),
    },
});
var api = axios.create({
    baseURL: apiURL,
    withCredentials: withCredentials,
    headers: {
        "Accept-Language": localStorage.getItem("i18nextLng"),
    },
});
export var client = axios.create();
base.interceptors.response.use(function (response) { return response; }, function (error) {
    if (isSessionTimeoutError(error)) {
        viewerReset();
    }
    return Promise.reject(error);
});
api.interceptors.response.use(function (response) { return response; }, function (error) {
    if (isSessionTimeoutError(error)) {
        viewerReset();
    }
    return Promise.reject(error);
});
export var http = {
    base: base,
    api: api,
};
